import React from "react";
import FilterCard, {FilterPart} from "../FilterCard";
import {Sample} from "../../types/Sample";
import {calculateAge} from "../../util/ValidationUtil";
import {sweetalert} from "../../App";
import {CustomFieldBuilder} from "../../customfields/CustomFieldBuilder";
import Validator, {ValidationEntry} from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import Overlay from "../Overlay";
import { hideModal, showModalNoOutsideClick, buildRow, getLabel, parseDate } from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";
import InBetweenOverlay from "../InBetweenOverlay";
import Select from "react-select";
import PhoneInput from 'react-phone-number-input';
import DatePicker from 'react-datepicker';
import moment from "moment";
import { Patient } from "../../types/Patient";



interface PatientInfoModalProps{
    submit:(e) => void,
    attachClearStateFunc?:(func) => void
    attachClearStateFuncGuardian?:(func) => void
    states:any
    gender:any
    ethnicity:any
    race:any
    countries:any
    portalPatients?
    fromWalkin?
}

interface PatientInfoModalState{
    showLoading:boolean
    showInBetween:boolean
    patientInfo?
    selectedPatient?
}
export class PatientInfoModal extends React.Component<PatientInfoModalProps, PatientInfoModalState>{
    public static ID = "patientinfo";
    constructor(props) {
        super(props);
        this.state ={
            showLoading: false,
            showInBetween: false,
            selectedPatient: null,
        }
        this.assignClearState = this.assignClearState.bind(this);
    }

    handleSave(){
        this.setState({showLoading: true}) 

        let tempDate = this.state.patientInfo.PatientDOB;
        if(typeof tempDate === 'object'){
            tempDate = parseDate(tempDate)
        }

        let patientInfoCopy = JSON.parse(JSON.stringify(this.state.patientInfo))
        patientInfoCopy.PatientFirstName = patientInfoCopy.PatientFirstName ? patientInfoCopy.PatientFirstName.trim() : null
        patientInfoCopy.PatientMiddleName = patientInfoCopy.PatientMiddleName ? patientInfoCopy.PatientMiddleName.trim() : null
        patientInfoCopy.PatientLastName = patientInfoCopy.PatientLastName ? patientInfoCopy.PatientLastName.trim() : null
        patientInfoCopy.PatientEmail = patientInfoCopy.PatientEmail ? patientInfoCopy.PatientEmail.trim() : null
        patientInfoCopy.PatientDOB = tempDate ? tempDate : null
        patientInfoCopy['confirmEmail'] = patientInfoCopy['confirmEmail'] ? patientInfoCopy['confirmEmail'].trim() : null
        patientInfoCopy.PatientAddress = patientInfoCopy.PatientAddress ? patientInfoCopy.PatientAddress.trim() : null
        patientInfoCopy.PatientAddress2 = patientInfoCopy.PatientAddress2 ? patientInfoCopy.PatientAddress2.trim() : null
        patientInfoCopy.PatientCity = patientInfoCopy.PatientCity ? patientInfoCopy.PatientCity.trim() : null
        patientInfoCopy.PatientZip = patientInfoCopy.PatientZip ? patientInfoCopy.PatientZip.trim() : null
        patientInfoCopy.PatientCounty = patientInfoCopy.PatientCounty ? patientInfoCopy.PatientCounty.trim() : null
        patientInfoCopy.PatientPhone = patientInfoCopy.PatientPhone ? patientInfoCopy.PatientPhone.trim() : null
        patientInfoCopy.GuardianFirstName = patientInfoCopy.GuardianFirstName && calculateAge(tempDate) < 18 ? patientInfoCopy.GuardianFirstName.trim() : ""
        patientInfoCopy.GuardianLastName = patientInfoCopy.GuardianLastName && calculateAge(tempDate) < 18 ? patientInfoCopy.GuardianLastName.trim() : ""

        if(!this.props.fromWalkin){
            delete patientInfoCopy.PatientAddress2
        }

        this.setState({patientInfo: patientInfoCopy})


        //validate patient info
        if(!PatientInfoModal.validatePatient(patientInfoCopy)){
            this.setState({showLoading: false})
            return
        }

        //pass back to parent
        this.props.submit({patientInfo: patientInfoCopy})

        hideModal(PatientInfoModal.ID)
        this.setState({showLoading: false})
        

    }


    public static validatePatient(s):boolean{
        let patientValidation = {
            PatientFirstName: s.PatientFirstName,
            PatientMiddleName: s.PatientMiddleName,
            PatientLastName: s.PatientLastName,
            PatientDOB: s.PatientDOB,
            PatientEmail: s.PatientEmail,
            ConfirmEmail: s['confirmEmail'],
            PatientGender: s.PatientGenderID,
            PatientAddress: s.PatientAddress,
            PatientAddress2: s.PatientAddress2,
            PatientCity: s.PatientCity,
            PatientZip: s.PatientZip,
            PatientState: s.PatientState,
            PatientCountry: s.PatientCountry,
            PatientCounty: s.PatientCounty,
            PatientPhone: s.PatientPhone,
            PatientEthnicity: s.PatientEthnicityID,
            PatientRace: s.PatientRaceID,
            GuardianFirstName: s.GuardianFirstName,
            GuardianLastName: s.GuardianLastName
        }

        let validator = new Validator<any>()
            .withValidation("PatientFirstName", Validators.requireNotBlankAndLength(50, "Patient First Name"))
        if(s.PatientMiddleName && s.PatientMiddleName.trim().length > 0){
            validator = validator.withValidation("PatientMiddleName", Validators.requireNotBlankAndLength(50, "Patient Middle Name"))
        }
        if(calculateAge(s.PatientDOB) < 18){
            validator = validator.withValidation("GuardianFirstName", Validators.requireNotBlankAndLength(50, "Guardian First Name")).withValidation("GuardianLastName", Validators.requireNotBlankAndLength(50, "Guardian Last Name"))
        }
        validator = validator.withValidation("PatientLastName", Validators.requireNotBlankAndLength(50, "Patient Last Name"))
            .withValidation("PatientDOB", Validators.requireDOB(150, "Patient Date of Birth"))
            .withComposedValidation("PatientEmail", new ValidationEntry(Validators.requireValidEmail("Patient Email")), Validators.requireNotBlankAndLength(100, "Patient Email"), new ValidationEntry<any>((key, attr, obj) =>{
                if (obj.PatientEmail !== s['confirmEmail']) {
                    return {success:false, error:"Patient Email and Confirmation Email do not match"};
                }
                return {success:true, error:null}
            }))
            .withSimpleValidation("PatientGender", Validators.requireNonNullValidator("Patient Gender"))
            .withValidation("PatientAddress", Validators.requireNotBlankAndLength(500, "Patient Address"))
            if(s.PatientAddres2){
                validator = validator.withValidation("PatientAddress2", Validators.requireNotBlankAndLength(500, "Patient Address2"))
            }
            validator = validator.withValidation("PatientCity", Validators.requireNotBlankAndLength(100, "Patient City"))
            .withComposedValidation("PatientZip", new ValidationEntry(Validators.requireNotBlankValidator("Patient Zipcode")), new ValidationEntry(Validators.requireZip("Patient Zipcode")))
            .withSimpleValidation("PatientState", Validators.requireNonNullValidator("Patient State"))
            .withSimpleValidation("PatientCountry", Validators.requireNonNullValidator("Patient Country"))
            .withValidation("PatientCounty", Validators.requireNotBlankAndLength(100, "Patient County"))
            .withComposedValidation("PatientPhone", new ValidationEntry(Validators.requireNonNullValidator("Patient Phone")), new ValidationEntry(Validators.requirePhone("Patient Phone")))
            .withSimpleValidation("PatientEthnicity", Validators.requireNonNullValidator("Patient Ethnicity"))
            .withSimpleValidation("PatientRace", Validators.requireNonNullValidator("Patient Race"))
        let validationResponse = validator.validate(patientValidation);
        if(!validationResponse.success) {
            sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
            return false
        }

        return true;
    }

    clearForWalkin = () => {
        this.setState({
            patientInfo: {
                PatientFirstName: "",
                PatientMiddleName: "",
                PatientLastName: "",
                PatientEmail: "",
                confirmEmail: "",
                PatientGenderID: null,
                PatientEthnicityID: null,
                PatientRaceID: null,
                PatientDOB: "",
                PatientState: null,
                PatientCountry: null,
                PatientAddress: "",
                PatientAddress2: "",
                PatientCity: "",
                PatientZip: "",
                PatientCounty: "",
                PatientPhone: "",
                GuardianFirstName: "",
                GuardianLastName: ""
            }, 
            selectedPatient: null
        })
    }

    clearFilterState:() => void = null;

    assignClearState(func){
        this.clearFilterState = func;
    }

    clearState = () =>{
        this.clearFilterState();
    }

    shouldComponentUpdate(nextProps: Readonly<PatientInfoModalProps>, nextState: Readonly<PatientInfoModalState>, nextContext: any): boolean {
        if(this.props.attachClearStateFunc)
            this.props.attachClearStateFunc(this.clearState)
        return true;
    }

    closeInBetween(){
        this.setState({showInBetween: false})
    }

    getQuestions():FilterPart[]{
        let questions:FilterPart[] = [];
        
        questions = questions.concat(CustomFieldBuilder.getPatientQuestions(this.props.gender, this.props.states, this.props.ethnicity, this.props.race, this.props.countries))

        return questions;
    }

    updateRows(e){
        this.setState({selectedPatient: e})
        let patientPortalInfo = e ? this.props.portalPatients.find(p => p.id === e.value) : []

        this.setState( (prevState) => ({
            patientInfo: {
                ...prevState.patientInfo,
                UID: patientPortalInfo.uid ? patientPortalInfo.uid : null,
                PatientFirstName: patientPortalInfo.firstName ? patientPortalInfo.firstName : '',
                PatientMiddleName: patientPortalInfo.middleName ? patientPortalInfo.middleName : '',
                PatientLastName: patientPortalInfo.lastName ? patientPortalInfo.lastName : '',
                PatientEmail: patientPortalInfo.email ? patientPortalInfo.email : '',
                confirmEmail: patientPortalInfo.email ? patientPortalInfo.email : '',
                PatientGenderID: patientPortalInfo.genderID ? patientPortalInfo.genderID : null,
                PatientEthnicityID: patientPortalInfo.ethnicityID ? patientPortalInfo.ethnicityID : null,
                PatientRaceID: patientPortalInfo.raceID ? patientPortalInfo.raceID : null, 
                PatientDOB: patientPortalInfo.dateOfBirth ? parseDate(patientPortalInfo.dateOfBirth) : '',
                PatientState: patientPortalInfo.state ? patientPortalInfo.state : null,
                PatientCountry: patientPortalInfo.country && patientPortalInfo.country === 'United States of America' ? 'United States' : patientPortalInfo.country ? patientPortalInfo.country : null,
                PatientAddress: patientPortalInfo.streetAddress ? patientPortalInfo.streetAddress : '',
                PatientAddress2: patientPortalInfo.streetAddress2 ? patientPortalInfo.streetAddress2 : '',
                PatientCity: patientPortalInfo.city ? patientPortalInfo.city : '',
                PatientZip: patientPortalInfo.zipcode ? patientPortalInfo.zipcode : '',
                PatientCounty: patientPortalInfo.county ? patientPortalInfo.county : '',
                PatientPhone: patientPortalInfo.phoneNumber ? patientPortalInfo.phoneNumber : '',
                GuardianFirstName: patientPortalInfo.guardianFirstName ? patientPortalInfo.guardianFirstName : '',
                GuardianLastName: patientPortalInfo.guardianLastName ? patientPortalInfo.guardianLastName : '',
            },

        }))
    }

    render() {

        // console.log('PatientInfoModal props', this.props)
        // console.log('PatientInfoModal state', this.state)

            return  (
                <React.Fragment>
                    <Overlay show_loading={this.state.showLoading} zIndex={100005}/>
                    <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100003} />
                    <div className="modal fade form_modal" id={PatientInfoModal.ID} tabIndex={-1} role="dialog"
                        aria-labelledby="result_modal_label"
                        aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-body p-0 m-0">
                                    <div className="container-fluid">
                                        <div className={"row"}>
                                            <div className="col-12 pt-2">
                                                <div className="card mt-2">
                                                    <div className="card-header verlag-bold">
                                                        <div className="row">
                                                            <div className="col-10">
                                                                <h4>
                                                                    Patient Information
                                                                </h4>
                                                            </div>
                                                            <div className="col-2">
                                                                <button style={{outline: 'none'}} type="button" className="close pr-4"
                                                                        aria-label="Close" onClick={() => hideModal(PatientInfoModal.ID)}>
                                                                    <span aria-hidden="true" style={{fontSize: '1.5em', fontWeight: 'bold'}}>&times;</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">

                                                        <div className={!this.props.fromWalkin ? "d-none": ""}>
                                                            <div className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={'"Search for existing patient'}>
                                                                <label htmlFor={'PatientSearch'} className="col-sm-4 col-form-label">{'Patient Search'}</label>
                                                                <div className="col-12 col-md-8 p-0 m-0" id={'PatientSearch'}>
                                                                <Select
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    placeholder={"Please Select..."}
                                                                    className={"state_select"}
                                                                    name={"Patient Search"}
                                                                    onChange={(e)=>{
                                                                        this.updateRows(e)
                                                                    }}
                                                                    value={this.state.selectedPatient}
                                                                    options={this.props.portalPatients?.map(p => {return {label: `${p.firstName} ${p.lastName} - ${parseDate(p.dateOfBirth)}`, value: p.id}})}
                                                                />
                                                                    <div className={this.state.selectedPatient ? "row" : "d-none"}>
                                                                        <div className="col-12 pr-1 mb-2 m-0 text-danger verlag-bold" style={{fontSize: '1rem'}} >*if patient information has changed, please edit the profile on the Patient Management page.</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        
                                                            {buildRow('First Name',
                                                                <input 
                                                                    id={'PatientFirstName'}
                                                                    className={"form-control"}
                                                                    maxLength={50}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientFirstName'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientFirstName: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientFirstName}
                                                            />, 'Patient First Name'
                                                            )}
                                                            {buildRow('Middle Name',
                                                                <input 
                                                                    id={'PatientMiddleName'}
                                                                    className={"form-control"}
                                                                    maxLength={50}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientMiddleName'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientMiddleName: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientMiddleName}
                                                            />, 'Patient Middle Name'
                                                            )}
                                                            {buildRow('Last Name',
                                                                <input 
                                                                    id={'PatientLastName'}
                                                                    className={"form-control"}
                                                                    maxLength={50}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientLastName'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientLastName: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientLastName}
                                                            />, 'Patient Last Name'
                                                            )}
                                                            {buildRow('Email to Receive Results',
                                                                <input 
                                                                    id={'Email'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'Email'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientEmail: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientEmail}
                                                            />, 'Patient Email'
                                                            )}
                                                            {buildRow('Confirm Email',
                                                                <input 
                                                                    id={'ConfirmEmail'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'ConfirmEmail'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                confirmEmail: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.confirmEmail}
                                                            />, 'Confirm Patient Email'
                                                            )}
                                                            {this.state.selectedPatient ? 
                                                                buildRow('Gender',
                                                                <input 
                                                                    id={'PatientGenderID'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'Gender'}
                                                                    disabled={this.state.selectedPatient}
                                                                    value={this.state.patientInfo?.PatientGenderID ? getLabel(this.state.patientInfo.PatientGenderID, this.props.gender).label : null}
                                                                />, 'Patient Gender'
                                                                )
                                                            :
                                                                buildRow('Gender',
                                                                    <Select
                                                                        key={'PatientGenderID'}
                                                                        id={'PatientGenderID'}
                                                                        isSearchable={true}
                                                                        placeholder={"Please Select..."}
                                                                        noOptionsMessage={()=> "No option"}
                                                                        value={this.state.patientInfo ? getLabel(this.state.patientInfo.PatientGenderID, this.props.gender) : null}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientGenderID: e.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        className={'state_select'}
                                                                        options={this.props.gender}
                                                                    />, 'Patient Gender'
                                                                )
                                                            }
                                                            {this.state.selectedPatient ? 
                                                                buildRow('Ethnicity',
                                                                <input 
                                                                    id={'PatientEthnicityID'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'Ethnicity'}
                                                                    disabled={this.state.selectedPatient}
                                                                    value={this.state.patientInfo?.PatientEthnicityID ? getLabel(this.state.patientInfo.PatientEthnicityID, this.props.ethnicity).label : null}
                                                                />, 'Patient Ethnicity'
                                                                )
                                                            :
                                                                buildRow('Ethnicity',
                                                                    <Select
                                                                        key={'PatientEthnicityID'}
                                                                        id={'PatientEthnicityID'}
                                                                        isSearchable={true}
                                                                        placeholder={"Please Select..."}
                                                                        noOptionsMessage={()=> "No option"}
                                                                        value={this.state.patientInfo ? getLabel(this.state.patientInfo.PatientEthnicityID, this.props.ethnicity) : null}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientEthnicityID: e.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        className={'state_select'}
                                                                        options={this.props.ethnicity}
                                                                    />, 'Patient Ethnicity'
                                                                )
                                                            }
                                                            {this.state.selectedPatient ?
                                                                buildRow('Race',
                                                                    <input 
                                                                        id={'PatientRaceID'}
                                                                        className={"form-control"}
                                                                        maxLength={100}
                                                                        autoComplete={"off"}
                                                                        type={"search"}
                                                                        name={'Race'}
                                                                        disabled={this.state.selectedPatient}
                                                                        value={this.state.patientInfo?.PatientRaceID ? getLabel(this.state.patientInfo.PatientRaceID, this.props.race).label : null}
                                                                    />, 'Patient Race'
                                                                    )
                                                            :
                                                                buildRow('Race',
                                                                    <Select
                                                                        key={'PatientRaceID'}
                                                                        id={'PatientRaceID'}
                                                                        isSearchable={true}
                                                                        placeholder={"Please Select..."}
                                                                        noOptionsMessage={()=> "No option"}
                                                                        value={this.state.patientInfo ? getLabel(this.state.patientInfo.PatientRaceID, this.props.race) : null}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientRaceID: e.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        className={'state_select'}
                                                                        options={this.props.race}
                                                                    />, 'Patient Race'
                                                                )
                                                            }
                                                            <div className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={'Patient Date of Birth'}>
                                                                <label htmlFor={'PatientDOB'} className="col-sm-4 col-form-label">{'Date of Birth'}</label>
                                                                <div className="col-12 col-md-8 p-0 m-0" id={'PatientDOB'}>
                                                                    <DatePicker
                                                                        style={{marginBottom: 0}}
                                                                        key={'PatientDOB'}
                                                                        id={'PatientDOB'}
                                                                        minDate={new Date('01-01-1000')}
                                                                        maxDate={new Date('12-31-9999')}
                                                                        placeholderText="--/--/----"
                                                                        disabled={this.state.selectedPatient}
                                                                        selected={Date.parse(moment(this.state.patientInfo?.PatientDOB, 'MM-DD-YYYY').toISOString())}
                                                                        onChange={(e) =>
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientDOB: e
                                                                                }
                                                                            }))
                                                                        }
                                                                    />
                                                                    <div className="row">
                                                                        <div className="col-12 pr-1 mb-2 m-0 text-danger verlag-bold" style={{fontSize: '1rem'}} >*please include ' / ' when entering date
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.selectedPatient ? 
                                                                buildRow('State',
                                                                    <input 
                                                                        id={'PatientState'}
                                                                        className={"form-control"}
                                                                        maxLength={100}
                                                                        autoComplete={"off"}
                                                                        type={"search"}
                                                                        name={'State'}
                                                                        disabled={this.state.selectedPatient}
                                                                        value={this.state.patientInfo?.PatientState ? getLabel(this.state.patientInfo.PatientState, this.props.states).label : null}
                                                                    />, 'Patient State'
                                                                )
                                                            :
                                                                buildRow('State',
                                                                    <Select
                                                                        key={'PatientState'}
                                                                        id={'PatientState'}
                                                                        isSearchable={true}
                                                                        placeholder={"Please Select..."}
                                                                        noOptionsMessage={()=> "No option"}
                                                                        value={this.state.patientInfo ? getLabel(this.state.patientInfo.PatientState, this.props.states) : null}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientState: e.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        className={'state_select'}
                                                                        options={this.props.states}
                                                                    />, 'Patient State'
                                                                )
                                                            }
                                                            {this.state.selectedPatient ? 
                                                                buildRow('Country',
                                                                    <input 
                                                                        id={'PatientCountry'}
                                                                        className={"form-control"}
                                                                        maxLength={100}
                                                                        autoComplete={"off"}
                                                                        type={"search"}
                                                                        name={'Country'}
                                                                        disabled={this.state.selectedPatient}
                                                                        value={this.state.patientInfo?.PatientCountry ? getLabel(this.state.patientInfo.PatientCountry, this.props.countries).label : null}
                                                                    />, 'Patient Country'
                                                                )
                                                            :
                                                                buildRow('Country',
                                                                    <Select
                                                                        key={'PatientCountry'}
                                                                        id={'PatientCountry'}
                                                                        isSearchable={true}
                                                                        placeholder={"Please Select..."}
                                                                        noOptionsMessage={()=> "No option"}
                                                                        value={this.state.patientInfo ? getLabel(this.state.patientInfo.PatientCountry, this.props.countries) : null}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    PatientCountry: e.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        className={'state_select'}
                                                                        options={this.props.countries}
                                                                    />, 'Patient Country'
                                                                )
                                                            }
                                                            {buildRow('Street Address',
                                                                <input 
                                                                    id={'PatientAddress'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientAddress'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientAddress: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientAddress}
                                                            />, 'Patient Street Address'
                                                            )}
                                                            {buildRow('Street Address cont.',
                                                                <input 
                                                                    id={'PatientAddress2'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientAddres2'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientAddress2: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientAddress2}
                                                            />, 'Patient Street Address cont'
                                                            )}
                                                            {buildRow('City',
                                                                <input 
                                                                    id={'PatientCity'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientCity'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientCity: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientCity}
                                                            />, 'Patient City'
                                                            )}
                                                            {buildRow('Zip',
                                                                <input 
                                                                    id={'PatientZip'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientZipcode'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientZip: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientZip}
                                                            />, 'Patient Zipcode'
                                                            )}
                                                            {buildRow('County',
                                                                <input 
                                                                    id={'PatientCounty'}
                                                                    className={"form-control"}
                                                                    maxLength={100}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={'PatientCounty'}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                PatientCounty: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.PatientCounty}
                                                            />, 'Patient County'
                                                            )}
                                                            {buildRow('Cell Phone',
                                                                <PhoneInput
                                                                    id={'PatientPhone'}
                                                                    placeholder={"Enter phone number"}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e) => 
                                                                        this.setState( (prevState) => ({
                                                                        patientInfo: {
                                                                            ...prevState.patientInfo,
                                                                            PatientPhone: e
                                                                        }
                                                                    }))}
                                                                    defaultCountry="US"
                                                                    value={this.state.patientInfo?.PatientPhone}/>
                                                            )}
                                                            <div className={this.state.patientInfo && calculateAge(this.state.patientInfo.PatientDOB) < 18 ? "" : "d-none"}>
                                                            {buildRow("Guardian First Name",
                                                                <input className={"form-control"}
                                                                    maxLength={50}
                                                                    autoComplete={"off"}
                                                                    type={"search"}
                                                                    name={"Guardian First Name"}
                                                                    disabled={this.state.selectedPatient}
                                                                    onChange={(e)=>{
                                                                        this.setState( (prevState) => ({
                                                                            patientInfo: {
                                                                                ...prevState.patientInfo,
                                                                                GuardianFirstName: e.target.value
                                                                            }
                                                                        }))
                                                                    }}
                                                                    value={this.state.patientInfo?.GuardianFirstName}
                                                                />
                                                            , 'Guardian first name'
                                                            )}
                                                            <div className="form-group row" data-toggle={'tooltip'} data-placement={'top'} title={'Guardian Last Name'}>
                                                                <label htmlFor={'GuardianLastName'} className="col-sm-4 col-form-label">{'Guardian Last Name'}</label>
                                                                <div className="col-12 col-md-8 p-0 m-0" id={'GuardianLastName'}>
                                                                    <input 
                                                                        className={"form-control"}
                                                                        maxLength={50}
                                                                        autoComplete={"off"}
                                                                        type={"search"}
                                                                        name={"Guardian Last Name"}
                                                                        disabled={this.state.selectedPatient}
                                                                        onChange={(e)=>{
                                                                            this.setState( (prevState) => ({
                                                                                patientInfo: {
                                                                                    ...prevState.patientInfo,
                                                                                    GuardianLastName: e.target.value
                                                                                }
                                                                            }))
                                                                        }}
                                                                        value={this.state.patientInfo?.GuardianLastName}
                                                                    />
                                                                    <div className="row">
                                                                        <div className="col-12 pr-1 mb-2 m-0 verlag-bold" style={{fontSize: '1rem'}}>*guardian info required for patients under the age of 18</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            </div>
                                                        </div>

                                                        <div className={this.props.fromWalkin ? "d-none" : ""}>
                                                            <FilterCard passClearStateFunc={this.assignClearState} fields={this.getQuestions()} filterChanged={(e)=>this.setState({patientInfo: e})}/>
                                                            <div className="small">*Guardian info required for patients under the age of 18</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer" style={{backgroundColor: 'transparent', borderTop: 'none'}}>
                                            <button className={"btn btn-primary float-right mb-3"} onClick={() => this.handleSave()}>Save</button>
                                         </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }

}